var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2496 13.7493H11.7621L15.8871 9.63676C16.1225 9.40138 16.2547 9.08213 16.2547 8.74926C16.2547 8.41638 16.1225 8.09713 15.8871 7.86176C15.6517 7.62638 15.3325 7.49414 14.9996 7.49414C14.6667 7.49414 14.3475 7.62638 14.1121 7.86176L7.86213 14.1118C7.74833 14.2306 7.65912 14.3708 7.59963 14.5243C7.4746 14.8286 7.4746 15.1699 7.59963 15.4743C7.65912 15.6277 7.74833 15.7679 7.86213 15.8868L14.1121 22.1368C14.2283 22.2539 14.3666 22.3469 14.5189 22.4104C14.6712 22.4738 14.8346 22.5065 14.9996 22.5065C15.1646 22.5065 15.328 22.4738 15.4803 22.4104C15.6327 22.3469 15.7709 22.2539 15.8871 22.1368C16.0043 22.0205 16.0973 21.8823 16.1607 21.73C16.2242 21.5777 16.2569 21.4143 16.2569 21.2493C16.2569 21.0842 16.2242 20.9209 16.1607 20.7685C16.0973 20.6162 16.0043 20.478 15.8871 20.3618L11.7621 16.2493H21.2496C21.5811 16.2493 21.8991 16.1176 22.1335 15.8831C22.3679 15.6487 22.4996 15.3308 22.4996 14.9993C22.4996 14.6677 22.3679 14.3498 22.1335 14.1154C21.8991 13.881 21.5811 13.7493 21.2496 13.7493Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.d104f88c3c0158e8ed7b6675b171a900.svg";
export { ForwardRef as ReactComponent };